import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type SaveTeam, useAuth } from 'prove-common'
import { checkTeamResponse } from './teamsUtils'

export function useTeamMutation(
  action: 'create' | 'edit' | 'delete',
  { invalidateOnSuccess = true }: { invalidateOnSuccess?: boolean } = {}
) {
  const { authFetch } = useAuth()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (team: SaveTeam & { id?: string }) => {
      const { id, ...body } = team
      const result =
        action === 'create'
          ? await authFetch().POST('/orgenhet-api/team', { body })
          : action === 'edit'
            ? await authFetch().PUT('/orgenhet-api/team/{teamid}', {
                body,
                params: { path: { teamid: Number(id) } }
              })
            : await authFetch().DELETE('/orgenhet-api/team/{teamid}', {
                params: { path: { teamid: Number(id) } }
              })
      checkTeamResponse(result)
    },
    onSuccess: async () => {
      if (!invalidateOnSuccess) return
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['teams'] }),
        queryClient.invalidateQueries({ queryKey: ['team'] })
      ])
    }
  })
}
